export default __webpack_public_path__ + "static/media/Novaa_Futurist_Still_4.c3e533b5.jpg";